/** Date helpers. Date-only strings (YYYY-MM-DD) are shown as-is, never shifted by a time zone. */

export type Lang = "id" | "en";

const locale = (lang: Lang) => (lang === "id" ? "id-ID" : "en-GB");

export function fmtDate(value: string | null | undefined, lang: Lang): string {
  if (!value) return "–";
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  const d = m ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])) : new Date(value);
  if (Number.isNaN(d.getTime())) return value;
  return new Intl.DateTimeFormat(locale(lang), { day: "2-digit", month: "short", year: "numeric" }).format(d);
}

export function fmtDateTime(value: string | null | undefined, lang: Lang): string {
  if (!value) return "–";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value;
  return new Intl.DateTimeFormat(locale(lang), {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(d);
}

/** Today as YYYY-MM-DD in the browser's local time (the date a worker means by "today"). */
export function todayLocal(): string {
  const d = new Date();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${d.getFullYear()}-${mm}-${dd}`;
}

export function fmtNumber(n: number, lang: Lang): string {
  return new Intl.NumberFormat(locale(lang)).format(n);
}
